import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/data/site";

export default function Prestations() {
  return (
    <>
      <Seo title="Prestations événementielles" description="Lancements de produits, ouvertures de boutique, inaugurations, galas, séminaires et congrès : toutes les prestations événementielles B2B de Désir Events." path="/prestations" />
      <PageHero
        eyebrow="Prestations"
        title={<>Chaque objectif,<br /><span className="italic text-lime-dim">son excellence.</span></>}
        subtitle="Du lancement produit à l'inauguration, nous couvrons l'ensemble des formats de l'événementiel d'entreprise."
      />

      <section className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <div className="flex flex-col gap-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={i % 3}>
              <Link to={`/prestations/${s.slug}`} className="group grid items-center gap-6 overflow-hidden rounded-2xl border border-ink/10 bg-white p-4 transition-all duration-500 hover:border-lime-dim/50 hover:shadow-lg hover:shadow-ink/5 md:grid-cols-12 md:p-5" data-testid={`prestation-row-${s.slug}`}>
                <div className="relative h-48 overflow-hidden rounded-xl md:col-span-3 md:h-32">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="md:col-span-1"><span className="font-serif text-3xl text-ink/20">0{i + 1}</span></div>
                <div className="md:col-span-5">
                  <h2 className="font-serif text-3xl font-medium text-ink group-hover:text-lime-dim md:text-4xl">{s.title}</h2>
                  <p className="mt-2 text-sm text-ink/55">{s.tagline}</p>
                </div>
                <p className="text-sm leading-relaxed text-ink/50 md:col-span-2">{s.short}</p>
                <div className="flex justify-start md:col-span-1 md:justify-end">
                  <ArrowUpRight size={26} className="text-ink/40 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-lime-dim" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
